import React from "react";

const BasicAppDevelopment = () => {
  return (
    <div className="mt-16 max-w-5xl mx-auto px-6 lg:px-8">
    <div className="bg-card border border-border/50 rounded-xl p-6 brand-shadow">
      <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
        <span className="w-1.5 h-6 bg-primary rounded-full"></span>
        Basic App Development Charges
      </h2>

      <div className="mt-6 space-y-4">
        <div className="flex justify-between items-center border-b border-border/30 pb-3">
          <span className="font-semibold text-foreground">
            Basic Android App Development
          </span>
          <span className="font-bold text-foreground">₹40K+</span>
        </div>

        <div className="flex justify-between items-center border-b border-border/30 pb-3">
          <span className="font-semibold text-foreground">
            Basic iOS App Development
          </span>
          <span className="font-bold text-foreground">₹40K+</span>
        </div>
      </div>

      <p className="mt-4 text-sm text-muted-foreground">
        * Basic app pricing covers only the features and scope discussed and
        finalized at the time of agreement. Any additional features,
        integrations, platform extensions (such as adding iOS after Android), or
        functional enhancements requested later will be treated as add-ons and
        charged separately. Final pricing may increase accordingly based on the
        nature and complexity of such additions.Includes core app setup,
        standard UI, basic navigation, and initial configuration.
      </p>
    </div></div>
  );
};

export default BasicAppDevelopment;
